import React, { Component } from "react";
import PropTypes from "prop-types";

import { Translate } from "react-redux-i18n";
import "../../../styles/utils/_loadingScreen.scss";
import Modal from "react-bootstrap/Modal";

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal id="confirmationModal" show={this.props.show} onHide={this.props.onHide} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <Translate value={this.props.title} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Translate value={this.props.body} />
            </p>
          </Modal.Body>
          <Modal.Footer>
            {this.props.loading  ? 
              <div className="loading-container">
                <div className="loading-spinner">
                  <div className="generic-loading">
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
              :
              <button
                type="button"
                className={this.props.btnClass ? this.props.btnClass : "primary-button"}
                onClick={this.props.onConfirm}
              >
                <Translate value={this.props.button} />
              </button>
            }

          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

ConfirmationModal.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
};

export default ConfirmationModal;
